import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivacySettingsContainer from './containers/privacy-settings/index';
import ActivityAssignPreferenceContainer from './containers/activity-assign-preference/index';

const Routes = () => (
    <Switch>
        <Route component={PrivacySettingsContainer} path="/privacySettings" />
        <Route component={ActivityAssignPreferenceContainer} path="/assignPreference" />
    </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./app/routes.js